import colors from '../../theme/foundations/colors'
import {fonts} from '../../theme/foundations/fonts'
import {pxToRem} from '../../utills/pxToRem'

export const variantValues = {
    fontWeight: 400,
    fontSize: {base: pxToRem(12), md: pxToRem(13)},
    color: colors.cav_light_input_gray,
    fontFamily: fonts.primary,
    letterSpacing: pxToRem(1),
    lineHeight: 'normal',
    m: 0,
    mb: pxToRem(1)
}

export const priceStyle = {
    fontFamily: fonts.primary,
    fontSize: {base: 'xs', lg: pxToRem(13)},
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'black'
}

export const salePriceStyle = {
    fontFamily: fonts.primary,
    fontSize: {base: 'xs', lg: pxToRem(13)},
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    color: 'cav_red',
    fontWeight: 'medium'
}

export const listPriceStyle = {
    fontFamily: fonts.primary,
    fontSize: {base: 'xs', lg: pxToRem(13)},
    lineHeight: 'normal',
    letterSpacing: pxToRem(1),
    fontWeight: 400
}
